import React, {useContext, useState} from 'react'
import {Avatar, Badge, Breadcrumb, Button, Card, Col, Flex, Form, Input, Row, Segmented, Space, Tabs} from "antd";
import {breadcrumbItemRender, getRole} from "services/utils";
import {FiChevronRight, FiUser} from "react-icons/fi";
import {LuLayoutDashboard} from "react-icons/lu";
import {Text} from "../../theme/typography";
import {COLORS, TYPOGRAPHY_SIZES} from "theme/constants";
import {UserContext} from "services/contexts";
import {FiCalendar} from "react-icons/fi";
import Moment from 'react-moment';
import 'moment/locale/es';
import {IoSaveOutline} from "react-icons/io5";

const items = [
    {
        path: '/',
        title: (<><LuLayoutDashboard/> <span>Projects</span></>),
    },
    {
        path: '/profile',
        title: 'User Profile'
    }
];


type PIFieldType = {
    first_name: string;
    last_name?: string;
    phone?: string;
    email: string;
    role?: string;
};

type SFieldType = {
    current_password: string;
    new_password?: string;
    confirm_password?: string;
};

const Profile = () => {
    const {user} = useContext(UserContext);
    return (
        <>
            <Space direction="vertical" size={"middle"} style={{width: '100%'}}>
                <Breadcrumb
                    separator={<FiChevronRight/>}
                    items={items}
                    itemRender={breadcrumbItemRender}
                />

                <Flex vertical={true}>
                    <Text weight={700} size={TYPOGRAPHY_SIZES.H5}>User Profile</Text>
                </Flex>

                <Card>
                    <Flex gap={"middle"} align={"center"}>
                        <Avatar style={{backgroundColor: COLORS.colorBgPrimary}} icon={<FiUser/>} size={84}/>

                        <Flex vertical={true}>
                            <Text weight={700} size={TYPOGRAPHY_SIZES.H7}>{user.first_name} {user.last_name}</Text>
                            <Text>{getRole(user)}</Text>

                            <Space>
                                <FiCalendar color={COLORS.colorSecondary}/>
                                Joined <Moment fromNow ago locale="en">{user.created_at}</Moment> ago
                            </Space>
                        </Flex>
                    </Flex>
                </Card>

                <Card>
                    <Tabs
                        defaultActiveKey="1"
                        items={[
                            {
                                label: 'Personal Information',
                                key: '1',
                                children: <>
                                    <Space direction={"vertical"} style={{width: '100%'}}>
                                        <Form
                                            name="profile_personal_info"
                                            autoComplete="off"
                                            layout="vertical"
                                            requiredMark={false}
                                            fields={[
                                                {name: "first_name", value: user.first_name},
                                                {name: "last_name", value: user.last_name},
                                                {name: "email", value: user.email},
                                                {name: "role", value: getRole(user)},
                                            ]}
                                        >

                                            <Row gutter={24}>
                                                <Col xs={{span: 24}} lg={{span: 12}}>
                                                    <Form.Item<PIFieldType>
                                                        name="first_name"
                                                        label={<strong>Name</strong>}
                                                        rules={[{required: true, message: "Name is required"}]}
                                                    >
                                                        <Input placeholder="Type your name"/>
                                                    </Form.Item>

                                                    <Form.Item<PIFieldType>
                                                        name="last_name"
                                                        label={<strong>Last Name</strong>}
                                                        rules={[{
                                                            required: true,
                                                            message: "Last name is required"
                                                        }]}
                                                    >
                                                        <Input placeholder="Type your lastname" value={user.last_name}
                                                               defaultValue={user.last_name}/>
                                                    </Form.Item>


                                                    <Form.Item<PIFieldType>
                                                        name="phone"
                                                        label={<strong>Phone</strong>}
                                                    >
                                                        <Input placeholder="Type your phone"/>
                                                    </Form.Item>
                                                </Col>

                                                <Col xs={{span: 24}} lg={{span: 12}}>
                                                    <Form.Item<PIFieldType>
                                                        name="email"
                                                        label={<strong>Email</strong>}
                                                        rules={[
                                                            {type: "email", message: "Invalid email"},
                                                            {required: true, message: "Email is required"},
                                                        ]}
                                                    >
                                                        <Input placeholder="user@email.com" disabled={true}/>
                                                    </Form.Item>

                                                    <Form.Item<PIFieldType>
                                                        name="role"
                                                        label={<strong>Role</strong>}
                                                    >
                                                        <Input placeholder="Type your role" disabled={true}/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>


                                            <Flex justify={"end"}>
                                                <Form.Item style={{marginTop: 50}}>
                                                    <Button
                                                        type="primary"
                                                        htmlType="submit"
                                                        style={{width: "100%"}}
                                                        icon={<IoSaveOutline/>}
                                                        iconPosition="start"
                                                    >
                                                       Save changes
                                                    </Button>
                                                </Form.Item>
                                            </Flex>
                                        </Form>
                                    </Space>
                                </>,
                            },
                            {
                                label: 'Security',
                                key: '2',
                                children: <>
                                    <Space direction={"vertical"} style={{width: '100%'}}>
                                        <Form
                                            name="profile_personal_info"
                                            autoComplete="off"
                                            layout="vertical"
                                            requiredMark={false}
                                            fields={[
                                                {name: "first_name", value: user.first_name},
                                                {name: "last_name", value: user.last_name},
                                                {name: "email", value: user.email},
                                                {name: "role", value: getRole(user)},
                                            ]}
                                        >

                                            <Row gutter={24}>
                                                <Col xs={{span: 24}} lg={{span: 12}}>
                                                    <Form.Item<SFieldType>
                                                        name="current_password"
                                                        label={<strong>Current Password</strong>}
                                                        rules={[{
                                                            required: true,
                                                            message: "Current password is requiered"
                                                        }]}
                                                    >
                                                        <Input.Password placeholder="••••••••"/>
                                                    </Form.Item>

                                                    <Form.Item<SFieldType>
                                                        name="new_password"
                                                        label={<strong>New Password</strong>}
                                                        rules={[{
                                                            required: true,
                                                            message: "New password is required"
                                                        }]}
                                                    >
                                                        <Input.Password placeholder="••••••••"/>
                                                    </Form.Item>


                                                    <Form.Item<SFieldType>
                                                        name="confirm_password"
                                                        label={<strong>Confirm password</strong>}
                                                        rules={[{
                                                            required: true,
                                                            message: "Confirm passwird is requiered"
                                                        }]}
                                                    >
                                                        <Input.Password placeholder="••••••••"/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>


                                            <Flex justify={"end"}>
                                                <Form.Item style={{marginTop: 50}}>
                                                    <Button
                                                        type="primary"
                                                        htmlType="submit"
                                                        style={{width: "100%"}}
                                                        icon={<IoSaveOutline/>}
                                                        iconPosition="start"
                                                    >
                                                        Save changes
                                                    </Button>
                                                </Form.Item>
                                            </Flex>
                                        </Form>
                                    </Space>
                                </>,
                            },
                        ]}
                    />

                </Card>
            </Space>


        </>
    )
}

export default Profile;